import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

function OrderHeader({ item }) {
  const theme = useTheme();
  return (
    <Box
      className='headerTile'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        className='tile'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: '90%', sm: '80%', md: '60%' },
          padding: 2,
          border: '1px solid #ccc',
          boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Typography variant='h5' sx={{ fontWeight: 600, mb: 1 }}>
          {item.price_details}
        </Typography>

        <Typography
          variant='body2'
          sx={{ fontSize: '0.8rem', textAlign: 'center', flexGrow: 1 }}
          dangerouslySetInnerHTML={{ __html: item.price_descr }}
        />

        <Typography
          sx={{
            fontSize: '1.2rem',
            textAlign: 'center',
            color: theme.palette.primary.highlight,
          }}
          dangerouslySetInnerHTML={{ __html: item.price_highlight }}
        />

        <Typography
          variant='body2'
          sx={{
            fontSize: '0.9rem',
            lineHeight: 1,
            textAlign: 'center',
            fontWeight: 600,
            my: 0.5,
          }}
        >
          Az előfizetés {item.valid_days} naponta megújul.
        </Typography>

        <Typography
          variant='body2'
          sx={{
            fontSize: '0.9rem',
            lineHeight: 1,
            textAlign: 'center',
            my: 0.5,
          }}
        >
          Az előfizetés lemondása a belépést követően profil oldalon lehetséges
        </Typography>
      </Box>
    </Box>
  );
}

export default OrderHeader;
